/* Bright Light LED - reposition the Shopify Forms teaser tab.
   The app renders a fixed-position tab inside a shadow root, pinned to
   the middle-right of the viewport, where it covered hero copy, product
   cards and the footer newsletter field. Shadow DOM means page CSS
   cannot reach it, so we inject a stylesheet into the shadow root. */
(function () {
  var CSS = '#app-embed[class*="ightMiddle"]{top:auto !important;bottom:16px !important;'
    + 'transform:none !important;}'
    + '@media (max-width:767px){#app-embed[class*="ightMiddle"]{bottom:10px !important;'
    + 'transform:scale(.88) !important;transform-origin:bottom right !important;}}';
  function patch() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (!sr || sr.querySelector('style[data-bl-teaser-fix]')) continue;
      var s = document.createElement('style');
      s.setAttribute('data-bl-teaser-fix', '1');
      s.textContent = CSS;
      sr.appendChild(s);
    }
  }
  patch();
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', patch); }
  var tries = 0;
  var t = setInterval(function () { patch(); if (++tries > 40) { clearInterval(t); } }, 250);
  if (window.MutationObserver) {
    new MutationObserver(patch).observe(document.documentElement, { childList: true, subtree: true });
  }
})();